module.exports = __webpack_public_path__ + "static/img/network.b3696186.jpg";